import {
  fetchAll,
  fetchFiltered,
  fetchVerifySerial,
  addOs,
  show,
  edit,
  inactivate,
  fetchCheckContractAndBoard,
  fetchAllPageOsList,
  fetchAllPageOsForm,
  confirmBillingEmitted,
  uploadAttatchment,
  fetchFilenamesAttachmentsByOs,
  fetchAttachmentByFilename,
  editDataOsFinished,
  editCauseOfMaintanceOsFinished,
  fetchOsActions,
  addOsAction
} from '@/api/os'
import { t } from '@/lib/i18n'

const state = {
  all: [],
  isLoading: false,
  osById: null,
  idCreated: undefined,
  showAttention: false,
  hasPaymentPending: false,
  idOsExisting: undefined,
  attatchments: [],
  osExisting: {},
  osActions: [],
  isLoadingOsActions: {
    show: false,
    message: ''
  },
  attatchmentByFilename: {},
  vehicleDataVerifySerial: {}
}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchById ({ dispatch, commit }, id) {
    try {
      const os = await show(id)
      commit('setOsById', os)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchAll ({ dispatch, commit }) {
    try {
      const os = await fetchAll()
      commit('setAll', os)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchFiltered ({ dispatch, commit }, queriesParams) {
    try {
      const os = await fetchFiltered(queriesParams)
        commit('setAll', os)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchSaveTestDate({ commit }, date) {
    return commit('setTestDate', date)
  },

  async fetchVerifySerial({ dispatch, commit }, serial) {
    try {
      dispatch('overlay/show', true, { root: true })

      const isLocadados = await fetchVerifySerial(serial)

      commit('setVehicleDataVerifySerial', isLocadados)

      return !isLocadados.CLI_ID
        ? 'notFound'
        : { cli_id: isLocadados.CLI_ID, vei_fld: isLocadados.VEI_FLD }

    } catch (error) {
      dispatch('notify/error', { message: t(error.message) }, { root: true })

      return 'error'
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },

  async create ({ dispatch, commit }, data) {
    try {
      commit('setLoading', true)
      dispatch('overlay/show', true, { root: true })

      const { osCreated, createdNewActive, hasPaymentPending } = await addOs(data)

      commit('setIdCreated', osCreated.id)
      commit('setShowAttention', createdNewActive)
      commit('setHasPaymentPending', hasPaymentPending)

      return true
    } catch (e) {
      if (e.message === 'serialExistsInOs') {
        commit('setIdOsExisting', e.id)
        commit('setOsExistingData', e.data)

        return true
      } else {
        let message = t(e.message) || e

        if (e.message === 'serialExistsInOsAndDifferentGarageAccredited') {
          message = `O serial informado já está na OS ${e.id} para outra Oficina Credenciada`
        }

        dispatch('notify/error', { message }, { root: true })
      }
    } finally {
      commit('setLoading', false)
      dispatch('overlay/show', false, { root: true })
    }
    return false
  },

  async edit ({ dispatch, commit }, { id, data }) {
    try {
      commit('setLoading', true)
      dispatch('overlay/show', true, { root: true })

      await edit(id, data)

      return true
    } catch (e) {
      if (e.message === 'serialExistsInOs') {
        commit('setIdOsExisting', e.id)
        return true
      } else {
        dispatch('notify/error', { message: t(e.message) || e }, { root: true })
      }
    } finally {
      commit('setLoading', false)
      dispatch('overlay/show', false, { root: true })
    }
    return false
  },

  async inactivate({ dispatch, commit }, id) {
    try {
      commit('setLoading', true)
      dispatch('overlay/show', true, { root: true })

      await inactivate(id)

      return true
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      commit('setLoading', false)
      dispatch('overlay/show', false, { root: true })
    }
    return false
  },

  async fetchCheckContractAndBoard ({ dispatch }, data) {
    try {
      dispatch('overlay/show', true, { root: true })

      await fetchCheckContractAndBoard(data)
      return true
    } catch (error) {
      return false
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },

  async fetchAllPageOsList ({ dispatch, commit }) {
    try {
      const all = await fetchAllPageOsList()
      commit('setAll', all)
    } catch (error) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchAllPageOsForm ({ dispatch, commit }) {
    try {
      const all = await fetchAllPageOsForm()
      commit('setAll', all)
    } catch (error) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async confirmBillingEmitted ({ dispatch, commit }, payload) {
    commit('setLoading', true)

    try {
      await confirmBillingEmitted(payload.os)
    } catch (e) {
      dispatch('notify/error', { message: t(e.message) || e }, { root: true })
    } finally {
      commit('setLoading', false)
    }
  },

  async uploadAttatchment ({ dispatch, commit }, payload) {
    commit('setLoading', true)

    try {
      await uploadAttatchment(payload)

      return true
    } catch (e) {
      console.log(t(e.message) || e)
      return false
      // dispatch('notify/error', { message: t(e.message) || e }, { root: true })
    } finally {
      commit('setLoading', false)
    }
  },

  async fetchFilenamesAttachmentsByOs ({ dispatch, commit }, id) {
    try {
      commit('setLoading', true)

      return await fetchFilenamesAttachmentsByOs(id)
    } catch (e) {
      dispatch('notify/error', e, { root: true })

      return []
    } finally {
      commit('setLoading', false)
    }
  },

  async fetchAttachmentByFilename ({ dispatch, commit }, payload) {
    try {
      const {
        filename,
        saveInArray = true
      } = payload

      commit('setLoading', true)

      const attatchment = await fetchAttachmentByFilename(filename)

      saveInArray
        ? commit('setAttatchments', attatchment)
        : commit('setAttatchmentByFilename', { filename, attatchment })
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      commit('setLoading', false)
    }
  },

  clearAttatchments ({ commit }) {
    commit('clearAttatchments')
  },

  async editDataOsFinished ({ dispatch, commit }, { id, data }) {
    try {
      commit('setLoading', true)

      await editDataOsFinished(id, data)

      return true
    } catch (e) {
      dispatch('notify/error', { message: t(e.message) || e }, { root: true })

      return false
    } finally {
      commit('setLoading', false)
    }
  },

  async editCauseOfMaintanceOsFinished ({ dispatch, commit }, { id, data }) {
    try {
      commit('setLoading', true)

      await editCauseOfMaintanceOsFinished(id, data)

      return true
    } catch (e) {
      dispatch('notify/error', { message: t(e.message) || e }, { root: true })

      return false
    } finally {
      commit('setLoading', false)
    }
  },

  clearOsActions({ commit }) {
    commit('setOsActions', [])
  },

  async fetchOsActions({ commit }, osId) {
    try {
      commit(
        'setLoadingOsActions',
        {
          show: true,
          message: 'Carregando ações ...'
        }
      )

      const osActions = await fetchOsActions(osId)

      commit('setOsActions', osActions)
    } catch (error) {
      console.log('[ERROR-FETCH-OS-ACTIONS] => ', error)
    } finally {
      commit('setLoadingOsActions', { show: false, message: '' })
    }
  },

  async addOsAction ({ dispatch, commit }, data) {
    commit('setLoadingOsActions', {
      show: true,
      message: 'Adicionando ação ...'
    })

    try {
      await addOsAction(data)

      return true
    } catch (error) {
      dispatch(
        'toast/showToast',
        {
          message: 'Erro ao adicionar ação!',
          type: 'error',
        },
        { root: true }
      );

      console.log('[ERROR-ADD-ACTION] => ', error);

      return false
    } finally {
      commit('setLoadingOsActions', {
        show: false,
        message: ''
      })
    }
  },
}

const mutations = {
  cleanState (state) {
    state.all = []
    state.isLoading = false
    state.osById = null
    state.showAttention = false
    state.hasPaymentPending = false
    state.idCreated = undefined
    state.idOsExisting = undefined
    state.attatchments = []
    state.attatchmentByFilename = {}
  },

  setAll (state, os) {
    state.all = os
  },

  setTestDate(state, date) {
    state.osById.testDate = date
  },

  setIdCreated(state, id) {
    state.idCreated = id
  },

  setIdOsExisting(state, id) {
    state.idOsExisting = id
  },

  setShowAttention(state, show) {
    state.showAttention = show
  },

  setHasPaymentPending(state, status) {
    state.hasPaymentPending = status
  },

  setOsById (state, os) {
    state.osById = {
      id: os.id,

      garageAccredited: typeof(os.garageAccredited) == 'object'
        ? os.garageAccredited ? os.garageAccredited.id : undefined
        : os.garageAccredited,

      technicalUsers: os.technicalUsers
        ? typeof os.technicalUsers == 'object' ? os.technicalUsers.id : os.technicalUsers
        : undefined,

      serial: os.serial,

      contract: typeof os.contract == 'object'
        ? os.contract.id_contrato
        : os.contract,

      board: os.board,
      brand: os.brand,
      model: os.model,
      color: os.color,
      year: os.year,
      vehicleType: os.vehicleType,
      odometer: os.odometer,

      services: typeof os.services == 'object'
        ? os.services.id
        : os.services,

      maintanceReason: os.maintanceReason
        ? typeof os.maintanceReason == 'object' ? os.maintanceReason.id : os.maintanceReason
        : undefined,

      withdrawnSerial: os.withdrawnSerial,
      obs: os.obs,
      travelPayment: os.travelPayment,
      kmTraveled: os.kmTraveled,
      activeList: os.activeList,
      testDate: os.testDate,
      requireSerial: os.requireSerial,
      vehicleAlreadyRegistered: os.vehicleAlreadyRegistered,
      trackerInstallationLocal: os.trackerInstallationLocal,
    }
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  },

  setAttatchments (state, attatchment) {
    state.attatchments = [
      ...state.attatchments,
      attatchment
    ]
  },

  setAttatchmentByFilename (state, payload) {
    state.attatchmentByFilename[payload.filename] = payload.attatchment
  },

  clearAttatchments (state) {
    state.attatchments = []
    state.attatchmentByFilename = {}
  },

  setOsExistingData(state, data) {
    state.osExisting = data
  },

  setOsActions(state, osActions) {
    state.osActions = osActions
  },

  setLoadingOsActions(state, isLoading) {
    state.isLoadingOsActions = isLoading
  },

  setVehicleDataVerifySerial(state, data) {
    state.vehicleDataVerifySerial = data
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
